import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_ADMIN_WORKFORCE_OVERVIEW_API } from "./apiRoutes";

interface Props {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getWorkforceOverview = async () => {
  return await axiosAuth.get(`${DASHBOARD_ADMIN_WORKFORCE_OVERVIEW_API}`);
};

const useGetWorkforceOverview = ({ queryParams }: Props = {}): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-admin-workforce-overview"],
    queryFn: () => getWorkforceOverview(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetWorkforceOverview;
